import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Modal, { ModalFooter } from '../modal';

@inject('accountStore')
@observer
export default class Settings extends Component {

  state = {
    position: [
      ['left','Слева'], 
      ['right', 'Справа']
    ],
    agreeCf: ['Никогда', 'Всегда', 'При повышении']
  };

  handleClick = (k, v) => {
    this.props.accountStore.toggleAccountSettings(k, v);
  }

  handleSelect = (k, e) => {
    this.props.accountStore.toggleAccountSettings(k, e.target.value);
  }

    render() {
        const {clearBasketAfterBet, loadRossLive, highlightChangesLive, colorizeSport, showHeaderBalance, gamesNumber, basketPosition, basketAgreeCf} = this.props.accountStore.accountSettings;
        return(
            <div className="box-account-settings">
                <div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className={`checkbox ${clearBasketAfterBet ? 'on' : ''}`} onClick={() => this.handleClick('clearBasketAfterBet', !clearBasketAfterBet)}>
                            <span></span>
                            Очищать корзину после ставки
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className={`checkbox ${loadRossLive ? 'on' : ''}`} onClick={() => this.handleClick('loadRossLive', !loadRossLive)}>
                            <span></span>
                            Загружать росписи
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        {/*<div className="hint_icon"></div>*/}
                        <div className={`checkbox ${highlightChangesLive ? 'on' : ''}`} onClick={() => this.handleClick('highlightChangesLive', !highlightChangesLive)}>
                            <span></span>
                            Подсвечивать изменения
                        </div>
                    </div>
                </div>
                <div className="row hidden">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className="box-highlight-changes-live-help-gif"></div>
                    </div>
                </div>
                {/*<div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className={`checkbox ${colorizeSport ? 'on' : ''}`} onClick={() => this.handleClick('colorizeSport', !colorizeSport)}>
                            <span></span>
                            Цветовое выделение видов спорта
                        </div>
                    </div>
                </div>*/}
                <div className="row hidden">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className="box-colorize-sport-help-gif"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className={`checkbox ${!showHeaderBalance ? 'on' : ''}`} onClick={() => this.handleClick('showHeaderBalance', !showHeaderBalance)}>
                          <span></span>
                          Скрыть баланс
                        </div>
                    </div>
                </div>
{/*                <div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className="fl_r box-account-settings-loader hidden"></div>
                        <div className="checkbox" onclick="checkbox(this);">
                            <span></span>
                            Табличные росписи в Линии
                        </div>
                    </div>
                </div>*/}
                <div className="row">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className={`checkbox ${gamesNumber ? 'on' : ''}`} onClick={() => this.handleClick('gamesNumber', !gamesNumber)}>
                            <span></span>
                            Номера событий в Линии
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="row-label">
                        <label htmlFor="as-basket-position">Корзина в Линии</label>
                    </div>
                    <div className="row-data row-data-input">
                        <select id="as-basket-position" onChange={e => this.handleSelect('basketPosition', e)}>
                          {this.state.position.map(el => (
                            <option key={el[0]} value={el[0]} selected={basketPosition == el[0]}>{el[1]}</option>
                            )
                          )}
                        </select>
                    </div>
                </div>
                {/*  <div className="row hidden">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className="checkbox" onclick="checkbox(this);">
                            <span></span>
                            Отображать всплывающие уведомления
                        </div>
                    </div>
                </div>*/}
                {/*<div className="row hidden">
                    <div className="row-label"></div>
                    <div className="row-data row-data-input">
                        <div className="checkbox" onclick="checkbox(this);">
                            <span></span>
                            Отображать всплывающие уведомления о ставках
                        </div>
                    </div>
                </div>*/}
                {/*<div className="row hidden">
                    <div className="row-label">
                        <label htmlFor="as-one-click-bet-amount">
                            Сумма ставки в 1 клик:
                        </label>
                    </div>
                    <div className="row-data row-data-input">
                        <input type="text" id="as-one-click-bet-amount" className="input" tabIndex="" value="" placeholder="50.00" />
                    </div>
                </div>*/}
                <div className="row">
                    <div className="row-label">
                        <label htmlFor="as-basket-agree-cf">Соглашаться с изм. кф.</label>
                    </div>
                    <div className="row-data row-data-input">
                        <select id="as-basket-agree-cf" onChange={e => this.handleSelect('basketAgreeCf', e)}>
                          {this.state.agreeCf.map((el, idx) => (
                            <option key={el} value={idx} selected={basketAgreeCf == idx}>{el}</option>
                            )
                          )}
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/account/settings.js